import { inject, Injectable, signal } from "@angular/core";
import { CardBinder, Page, Scan } from "@models/binder.model";
import { Api } from "@services/api.service";
import { Subject, tap } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class ScannerService{
	//service
	readonly api=inject(Api);

	//data
	readonly type=signal<ScanActionType>('binder');
	private target: string=null;							//target = binder si on est sur un scan de page, target = page si on est sur un scan de carte
	readonly resultPage=new Subject<PageApiResponse>();
	readonly resultCard=new Subject<CardApiResponse>();
	readonly resultRmPage=new Subject<CardBinder>();
	readonly resultRefreshCard=new Subject<CardBinder>();

	//ui
	readonly enabled=signal(false);

	disable(){
		this.enabled.set(false);
	}

	enable(type: ScanActionType, target: string){
		this.target=target;
		this.type.set(type);
		this.enabled.set(true);
	}

	scanPageTotarget(img: File){
		return this.scanPage(img, this.target);
	}

	scanPage(img: File, binder: string){
		return this.api.post<PageApiResponse>(`/scans/${binder}`, Api.toFormData({img}))
			.pipe(
				tap(response => this.resultPage.next(response))
			);
	}

	refreshPageTotarget(img: File){
		return this.refreshPage(img, this.target);
	}

	refreshPage(img: File, page: string){
		return this.api.post<PageApiResponse>(`/pages/${page}/refresh`, Api.toFormData({img}))
			.pipe(
				tap(response => this.resultPage.next(response))
			);
	}

	scanCardToTarget(img: File){
		return this.scanCard(img, this.target);
	}

	scanCard(img: File, page: string){
		return this.api.post<CardApiResponse>(`/cards/${page}`, Api.toFormData({img}))
			.pipe(
				tap(response => this.resultCard.next(response))
			);
	}

	refreshCardtoTarget(img: File){
		return this.refreshCard(img, this.target);
	}

	refreshCard(img: File, card: string){
		return this.api.post<CardApiResponse>(`/cards/${card}/refresh`, Api.toFormData({img}))
			.pipe(
				tap(response => this.resultRefreshCard.next(response))
			);
	}

	rmPageTargert(){
		return this.rmPage(this.target)
			.pipe(
				tap(response => this.resultRmPage.next(response))
			);
	}

	rmPage(page: string){
		return this.api.delete<Page>(`/pages/${page}`);
	}
}

export type PageApiResponse={page: Page, scan: Scan};
export type CardApiResponse={card: CardBinder, scan: Scan};
type ScanActionType='binder' | 'page' | 'card';
